import { INACTIVITY_TIMEOUT } from "@/constants/util.constants";
import localforage from "localforage";
import md5 from "md5";

const PIN_KEY = "user_pin";
const PIN_TIMESTAMP_KEY = "pin_timestamp";

export async function setPin(pin: string): Promise<void> {
  const hashedPin = md5(pin);
  await localforage.setItem(PIN_KEY, hashedPin);
  await localforage.setItem(PIN_TIMESTAMP_KEY, Date.now());
}

export async function validatePin(pin: string): Promise<boolean> {
  const hashedPin = md5(pin);
  const storedPin = await localforage.getItem<string>(PIN_KEY);
  return hashedPin === storedPin;
}

export async function isPinExpired(): Promise<boolean> {
  const timestamp = await localforage.getItem<number>(PIN_TIMESTAMP_KEY);
  if (!timestamp) return true;

  const elapsedTime = Date.now() - timestamp;
  return elapsedTime > INACTIVITY_TIMEOUT;
}

export async function expirePin(): Promise<void> {
  await localforage.removeItem(PIN_TIMESTAMP_KEY);
}

export async function refreshPinTimestamp(): Promise<void> {
  await localforage.setItem(PIN_TIMESTAMP_KEY, Date.now());
}

// is pin set
export async function isPinSet(): Promise<boolean> {
  const pin = await localforage.getItem<string>(PIN_KEY);
  return !!pin;
}

// get timestamp
export async function getPinTimestamp(): Promise<number | null> {
  const timestamp = await localforage.getItem<number>(PIN_TIMESTAMP_KEY);
  return timestamp !== null ? timestamp : null;
}

// Check that pin and pin_timestamp are set, if both exist, return true
export async function isStoreValid(): Promise<boolean> {
  const pin = await localforage.getItem<string>(PIN_KEY);
  const storedAttempts = await localforage.getItem<number>("attempts");
  return !!pin && storedAttempts !== null && storedAttempts !== undefined;
}
